import { render } from "./App.vue?vue&type=template&id=31c0816d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=31c0816d&lang=css"

import exportComponent from "C:\\Users\\murat\\OneDrive\\mkss\\source\\vuejs\\practiceone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__